/* tslint:disable */
/* eslint-disable */
/**
 * Portfolio-tracker
 * Portfolio-tracker
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    LookupKeyEnum,
    LookupKeyEnumFromJSON,
    LookupKeyEnumFromJSONTyped,
    LookupKeyEnumToJSON,
} from './LookupKeyEnum';

/**
 * 
 * @export
 * @interface CreateCheckoutSessionDto
 */
export interface CreateCheckoutSessionDto {
    /**
     * 
     * @type {LookupKeyEnum}
     * @memberof CreateCheckoutSessionDto
     */
    lookupKey: LookupKeyEnum | null;
}

export function CreateCheckoutSessionDtoFromJSON(json: any): CreateCheckoutSessionDto {
    return CreateCheckoutSessionDtoFromJSONTyped(json, false);
}

export function CreateCheckoutSessionDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateCheckoutSessionDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'lookupKey': LookupKeyEnumFromJSON(json['lookupKey']),
    };
}

export function CreateCheckoutSessionDtoToJSON(value?: CreateCheckoutSessionDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'lookupKey': LookupKeyEnumToJSON(value.lookupKey),
    };
}

